<template>
  <div class="expandableDocumentation">
    <h1 class="medium-title"> Using Expandable Listing Item</h1>
    <adx-expandable-listitems 
      :data="data"
      :customAdsButton="true" 
      @removeFromCampaign="removeFromCampaign"
      @toggleSave="toggleSave" 
      @addToCampaign="addToCampaign"
      @goToDetail="goToDetail"
      @previewImage="previewImage"
      @showModal="showModal"
      />
    <br/><br/>
    <h1> Using Expandable Without Button View Photos</h1>
    <adx-expandable-listitems 
      :data="data"
      :customAdsButton="true" 
      :viewPhotos="false"
      :buttonSaved="false"
      @removeFromCampaign="removeFromCampaign"
      @toggleSave="toggleSave" 
      @addToCampaign="addToCampaign"
      @goToDetail="goToDetail"
      @previewImage="previewImage"
      @showModal="showModal"
      />
    <br/><br/>
    <h1 class="medium-title"> Using Custom Expandable List</h1>

    <div class="custom-expandable">
    <adx-custom-expandable-list
      :data="data1"
      :customAdsButton="true" 
      :tagPhotos="true"
      @removeFromCampaign="removeFromCampaign"
      @toggleSave="toggleSave" 
      @addToCampaign="addToCampaign"
      @goToDetail="goToDetail"
      @previewImage="previewImage"
      @showModal="showModal"
      >

      <div class="expandableParent" :slot="['topcontent', index].join('-')" v-for="(item,index) in data" :key="'custom_'+index">
        <div class="expandableParent__image">
          <img :src="item.icon"/>
        </div>
        <div class="expandableParent__route">
          <div class="color-grey micro-font"> ROUTE </div>
          <div class="regular-font strong">{{item.title}}</div>
        </div>
        <div class="expandableParent__bustype">
          <div class="color-grey micro-font"> BUS TYPE </div>
          <div class="regular-font">Big Bus</div>
        </div>
        <div class="expandableParent__trip">
          <div class="color-grey micro-font"> EST. TRIP </div>
          <div class="regular-font">12 per day</div>
        </div>
        <div class="expandableParent__distance">
          <div class="color-grey micro-font"> TRIP DISTANCE </div>
          <div class="regular-font"> 20.000 km</div>
        </div>
      </div>  
    </adx-custom-expandable-list>
    </div>
    <br/><br/>
    <h1 class="medium-title"> Using Expandable Level 2</h1>
    <div class="level2-expandable" v-for="(item, index) in media"  :key="index">
      <adx-expandable-level2 :item="item" :list="data[0]"
        :viewPhoto="true" :isHideSaved="true" :tagPhoto="true"
        @toggleSave="toggleSave" 
        @addToCampaign="addToCampaign"
        @goToDetail="goToDetail"
        @previewImage="previewImage"
      />
    </div>
    
  </div>

</template>

<script>
import CustomExpandableList from '@/components/ExpandableListItems/CustomExpandableList'
import ExpandableListItems from '@/components/ExpandableListItems'
import ExpandableLevel2 from '@/components/ExpandableListItems/Level2'

export default {
  name: 'adx-expandable-listitems-documentation',
  components: {
    'adx-custom-expandable-list': CustomExpandableList,
    'adx-expandable-listitems': ExpandableListItems,
    'adx-expandable-level2' : ExpandableLevel2
  },
  props: {

  },
  data() {
    let transjakartaIcon = `/img/bus/transjakarta-icon@3x.png`;
    let damriIcon =`/img/bus/damri-icon@3x.png`;
    return {
      data: [
        {
          icon: transjakartaIcon,
          title: "Meirton",
          description: "tes",
          property_type: "ML",
          street: "Jalan Cawang Utara no.1",
          cluster_name: "Cawang",
          province_name: "DKI Jakarta",
          city_name: "Jakarta Timur",
          country_name: "Indonesia",
          zipcode: "",
          traffic: 1000,
          slug: "meirton",
          category_display: "malls",
          class: "PR",
          primary_photo: "/img/collection/airport_lounge.jpg",
          media: [
            {
              isAdded: true,
              saved: true,
              price: 200000000,
              period: null,
              placement: "Meirton",
              media_name: "device",
              include_tax: false,
              description: "This is a description for Meirton",
              title: "Meirton1",
              photo: "/img/collection/airport_lounge.jpg"
            },
            {
              isAdded: false,
              saved: false,
              price: 2000000,
              period: null,
              placement: "Meirton",
              media_name: "device",
              include_tax: false,
              description: "This is a description for Meirton",
              title: "Meirton2",
              photo: "/img/collection/airport_lounge.jpg"
            }
          ]
        },
        {//ga pake property_type sama media_name
          icon: damriIcon,
          title: "128 Prinsep Street, 188655",
          description: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Suspendisse porttitor interdum blandit. Vivamus lorem neque, rutrum tincidunt neque a, hendrerit consequat quam. Nunc dignissim gravida dignissim. Nunc a rhoncus augue, in vulputate neque. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nunc ullamcorper ornare elementum. Fusce quis tellus sed tortor porttitor malesuada et dapibus mi.",
          street: "Jalan Prinsip Dalam no.69",
          cluster_name: "Grogol",
          province_name: "-",
          city_name: "Jakarta Barat",
          country_name: "-",
          zipcode: "",
          traffic: 0,
          slug: "128-prinsep-street-188655",
          category_display: "lifestyle",
          primary_photo: "/img/collection/airport_lounge.jpg",
          media: [
            {
              saved: true,
              price: 4000000,
              period: null,
              placement: "depan",
              include_tax: true,
              description: null,
              title: "128 Prinsep Street, 188655",
              photo: "/img/collection/airport_lounge.jpg"
            }
          ]
        },
        {
          icon: transjakartaIcon,
          title: "Jurong Point, 1 Jurong West Central 2, 648886",
          description: "Basement level, In front of Ayam Penyet, under the escalators.",
          property_type: "AR",
          street: "Jurong Utama, kavling 4, Ruko Mexico.",
          cluster_name: "Daan Mogot",
          province_name: "-",
          city_name: "Jakarta Barat",
          country_name: "-",
          zipcode: "",
          traffic: 0,
          slug: "jurong-point-1-jurong-west-central-2-648886",
          category_display: "airport",
          primary_photo: "/img/collection/airport_lounge.jpg",
          media: [
            {
              isAdded: true,
              saved: false,
              price: 3000000,
              period: null,
              placement: "Depan",
              media_name: "device",
              include_tax: false,
              description: null,
              title: "Jurong Point, 1 Jurong West Central 2, 648886",
              photo: "/img/collection/airport_lounge.jpg"
            }
          ]
        }
      ],
      data1: [
        {
          icon: transjakartaIcon,
          title: "Meirton",
          description: "tes",
          property_type: "ML",
          street: "Jalan Cawang Utara no.1",
          cluster_name: "Cawang",
          province_name: "DKI Jakarta",
          city_name: "Jakarta Timur",
          country_name: "Indonesia",
          zipcode: "",
          traffic: 1000,
          slug: "meirton",
          category_display: "malls",
          class: "PR",
          primary_photo: "/img/collection/airport_lounge.jpg",
          media: [
            {
              isAdded: true,
              saved: true,
              price: 200000000,
              period: null,
              placement: "Meirton",
              media_name: "device",
              include_tax: false,
              description: "This is a description for Meirton",
              title: "Meirton1",
              photo: [
                "/img/collection/airport_lounge.jpg",
                "/img/collection/airport_lounge.jpg",
                "/img/collection/airport_lounge.jpg",
                "/img/collection/airport_lounge.jpg"
              ],
              thumbnail: "/img/collection/airport_lounge.jpg",
            },
            {
              isAdded: false,
              saved: false,
              price: 2000000,
              period: null,
              placement: "Meirton",
              media_name: "device",
              include_tax: false,
              description: "This is a description for Meirton",
              title: "Meirton2",
              photo: [
                "/img/collection/airport_lounge.jpg",
                "/img/collection/airport_lounge.jpg"
              ]
            }
          ]
        },
        {//ga pake property_type sama media_name
          icon: damriIcon,
          title: "128 Prinsep Street, 188655",
          description: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Suspendisse porttitor interdum blandit. Vivamus lorem neque, rutrum tincidunt neque a, hendrerit consequat quam. Nunc dignissim gravida dignissim. Nunc a rhoncus augue, in vulputate neque. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nunc ullamcorper ornare elementum. Fusce quis tellus sed tortor porttitor malesuada et dapibus mi.",
          street: "Jalan Prinsip Dalam no.69",
          cluster_name: "Grogol",
          province_name: "-",
          city_name: "Jakarta Barat",
          country_name: "-",
          zipcode: "",
          traffic: 0,
          slug: "128-prinsep-street-188655",
          category_display: "lifestyle",
          primary_photo: "/img/collection/airport_lounge.jpg",
          media: [
            {
              saved: true,
              price: 4000000,
              period: null,
              placement: "depan",
              include_tax: true,
              description: null,
              title: "128 Prinsep Street, 188655",
              photo: [
                "/img/collection/airport_lounge.jpg",
                "/img/collection/airport_lounge.jpg"
              ],
              thumbnail: "/img/collection/airport_lounge.jpg",
            }
          ]
        },
        {
          icon: transjakartaIcon,
          title: "Jurong Point, 1 Jurong West Central 2, 648886",
          description: "Basement level, In front of Ayam Penyet, under the escalators.",
          property_type: "AR",
          street: "Jurong Utama, kavling 4, Ruko Mexico.",
          cluster_name: "Daan Mogot",
          province_name: "-",
          city_name: "Jakarta Barat",
          country_name: "-",
          zipcode: "",
          traffic: 0,
          slug: "jurong-point-1-jurong-west-central-2-648886",
          category_display: "airport",
          primary_photo: "/img/collection/airport_lounge.jpg",
          media: [
            {
              isAdded: true,
              saved: false,
              price: 3000000,
              period: null,
              placement: "Depan",
              media_name: "device",
              include_tax: false,
              description: null,
              title: "Jurong Point, 1 Jurong West Central 2, 648886",
              thumbnail: "/img/collection/airport_lounge.jpg",
              photo: [
                "/img/collection/airport_lounge.jpg",
                "/img/collection/airport_lounge.jpg"
              ]
            }
          ]
        }
      ],
      media: [
        {
          isAdded: true,
          saved: true,
          price: 2000000,
          period: null,
          placement: "Meirton",
          media_name: "device",
          include_tax: false,
          description: "This is a description for Meirton",
          title: "Meirton1",
          photo: [
            "/img/collection/airport_lounge.jpg",
            "/img/collection/airport_lounge.jpg"
          ],
          thumbnail: "/img/collection/airport_lounge.jpg",
        },
        {
          isAdded: true,
          saved: true,
          price: 2000000,
          period: null,
          placement: "Meirton",
          media_name: "device",
          include_tax: false,
          description: "This is a description for Meirton",
          title: "Meirton2",
          photo: [
            "/img/collection/airport_lounge.jpg",
            "/img/collection/airport_lounge.jpg"
          ],
          thumbnail: "/img/collection/airport_lounge.jpg",
        }
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggleSave(list, item){
      this.$notify({
        group: 'saved',
        title: 'Added to campaign',
        text: "Saved",
        type: 'success'
      });
      console.log('toggleSave', list, item)
    },
    addToCampaign(list, item) {
      this.$notify({
        group: 'saved',
        title: 'Added to campaign',
        text: "Added to campaign",
        type: 'success'
      });
      console.log('addToCampaign', list, item)
    },
    removeFromCampaign(item, list){
      this.$notify({
        group: 'saved',
        title: 'Removed from campaign',
        text: "Removed from campaign",
        type: 'success'
      });
      console.log('removeFromCampaign', item, list)
    },
    goToDetail(item, list) {
      this.$notify({
        group: 'saved',
        title: 'Added to campaign',
        text: "Go To Detail",
        type: 'success'
      });
      console.log('goToDetail', item, list)
    },
    previewImage(item){
      console.log('PreviewImage', item)
    },
    showModal(){
      console.log('Show Modal')
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>